import "./loader.css";
const Loader = () => {
  return <div className="loading"></div>;
};

export { Loader };
